module.exports = __webpack_public_path__ + "static/media/kaduha_mugano_mushubi_road9.19ffadae.jpg";